<template>
   <table class="table table-hover" v-bind:style="[ showHeader ? 'border: 1px solid #dcdede;' : '' ]">
                <thead class="thead-third" v-if="columns">
                <slot name="header"></slot>
                <tr>
                    <th class="text-center w-16">{{title}}</th>
                    <th class="text-center w-16">{{formatMoney(totalSaleValue)}}</th>
                    <th class="text-center w-16">Data</th>
                    <th class="text-center w-16">{{totalBrokers}} Corretor(es)</th>
                    <th class="text-center w-16">Unidades Vendidas</th>
                    <th class="text-center w-17">% da Comissão</th>
                </tr>
                </thead>
                <thead class="thead-third" v-else>
                <slot name="thead"></slot>
                </thead>
                <tbody>
                <tr v-for="(row,i) in rows" :key="i">
                    <td class="text-center">{{row.nomeCorretor}}</td>
                    <td class="text-center">{{formatMoney(row.valorTotal)}}</td>
                    <td class="text-center">{{row.data}}</td>
                    <td class="text-center"></td>
                    <td class="text-center">{{row.unidadeVendidas}}</td>
                    <td class="text-center"></td>
                </tr>
                </tbody>
          </table>
</template>

<script scoped>
import tablesalereportmonth from './tablesalereportmonth'
export default tablesalereportmonth
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/salesreportsbroker/components/tablesalereportmonth/tablesalereportmonth.vue